const buildAddress = (appData, withPostcode = false) => {
  const isAddress = appData.address;
  const allowed = [
    "addressLine1",
    "town",
    "county",
    "country",
    withPostcode ? "postcode" : "",
  ];
  if (isAddress) {
    return allowed
      .filter((key) => Object.keys(appData.address).includes(key))
      .map((address) => {
        return appData.address[address];
      })
      .join(", ");
  }
  return "";
};

export default buildAddress;
